<script lang="ts">
  interface SortValue {
    value: string;
    displayName: string;
    displayShortName: string;
    isDefault: boolean;
  }

  interface Props {
    ruleString: string;
    selectedSortOrder: string;
    nBFDesktopActive: boolean;
    values: string; /*                                                          */
    useSelectChip: boolean;
  }

  const { ruleString, selectedSortOrder, nBFDesktopActive, values, useSelectChip }: Props = $props();

  const parsedValues: SortValue[] = $derived(JSON.parse(values));
</script>

<div id="heureka_desktopSorting--initialization" hidden>
  <form
    class={`heureka_sorting ts_sortingForm${nBFDesktopActive ? " find_sorting--NBF " : ""}`}
    action="/grasshopper/filter/resolve"
    autocomplete="off"
    method="post"
    novalidate
  >
    <input type="hidden" name="rule" value={ruleString} />
    <input type="hidden" name="l" value="" />
    <fieldset class="heureka_sorting__relevantValues"></fieldset>
    {#if useSelectChip}
      <hc-select-chip {values} selected-value={selectedSortOrder}></hc-select-chip>
    {:else}
      <oc-chip-v2 class="heureka_sorting__dropdown">
        <label class="heureka_sorting__label" for="heureka_desktopSorting--select">Sortieren nach:</label>
        <select
          id="heureka_desktopSorting--select"
          name="sortiertnach"
          required={true}
          class="heureka_sorting__select heureka_sorting__select--harmonized"
        >
          {#each parsedValues as sortValue (sortValue.value)}
            <option selected={sortValue.value === selectedSortOrder} value={sortValue.value}
              >{sortValue.displayName}</option
            >
          {/each}
        </select>
      </oc-chip-v2>
    {/if}
  </form>
</div>
